let radioButton = {
  radioButtonFirst: "RADIO_BUTTON_FIRST",
  radioButtonSecond: "RADIO_BUTTON_SECOND",
  radioButtonThird: "RADIO_BUTTON_THIRD",
};

export { radioButton };
